function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* eslint-disable react/prop-types */
//Radio buttons. name is requried.
//options are an array of choices or
//array of {value:, text:} objects.or:
/*
options: {
  single: 'Single',
  married: 'Married'
},
*/

// Import packages
import React from 'react';

// Import styles
import { _RadioWrapper, _RadioLabel, _RadioButton, _RadioSpan } from "./inputStyles";
var Radio = function Radio(props) {
  return /*#__PURE__*/React.createElement(_RadioWrapper, {
    noPadding: props.noPadding
  }, props.options && Object.entries(props.options).map(function (arr, i) {
    var value;
    var text;
    if (arr[1] && _typeof(arr[1]) === 'object') {
      value = arr[1].value;
      text = arr[1].text;
    } else {
      value = arr[0];
      text = arr[1];
    }
    var inputValue = props.inputValue === undefined ? props.input && props.input.value : props.inputValue;
    var c = value == inputValue;
    return /*#__PURE__*/React.createElement(_RadioLabel, {
      key: value
    }, /*#__PURE__*/React.createElement(_RadioButton, {
      "data-inputid": props.inputId,
      "data-order": i,
      checked: c && 'checked',
      name: props.name,
      key: value,
      onChange: props.onChange || props.input && props.input.onChange,
      type: "radio",
      value: value,
      disabled: props.disabled
    }), /*#__PURE__*/React.createElement(_RadioSpan, null, text));
  }));
};
export default Radio;